module.exports = __webpack_public_path__ + "img/OpenSans-Light.7d9b2e9d.svg";